/* ============================================================================
   BARA BROS · MOBILE MEGA MENU — FX ENGINE  (mobile-mega-menu-fx.js)
   ----------------------------------------------------------------------------
   ADDITIVE + COLLISION-SAFE. This file NEVER opens/closes the drawer, switches
   tabs, drives L3, or touches coupon-copy / product reveal. It only:
     • paints the Matrix Rain canvas into [data-mmm-matrix]
     • assigns --i indices for staggered entrance animation
     • flags empty tiles (.is-empty) + injects a category initial
   It reacts to the drawer opening via MutationObserver, so it has ZERO
   dependency on the existing drawer JS API.

   Load order: after the existing mega-menu JS. Defer is fine.
   All work is gated to mobile (<=989px) and respects prefers-reduced-motion.
   ============================================================================ */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 989px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DRAWER_SEL = '#Drawer-Menu';

  /* ---- character sets for matrix presets ---------------------------------- */
  var CHARSETS = {
    japanese_numbers: 'アイウエオカキクケコサシスセソタチツテト0123456789',
    bara_rose:        '薔薇愛雄漢❤♂01ｱｲｳｴｵﾊﾐﾋ',
    love_code:        '❤♥01LOVEｱｲｳ愛',
    cyber_katakana:   'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉ◆◇▲△●',
    numbers_only:     '0123456789',
    custom:           ''
  };

  /* ========================================================================
     MATRIX RAIN — lightweight canvas, one per [data-mmm-matrix] host.
     Reads config from data-* on the host (set in markup-inserts.liquid).
     ======================================================================== */
  function MatrixRain(host) {
    this.host = host;
    this.canvas = document.createElement('canvas');
    host.appendChild(this.canvas);
    this.ctx = this.canvas.getContext('2d');
    this.raf = 0; this.last = 0; this.running = false;
    this.paused = false;
    this.cfg = this.readCfg();
    this.scrollHandler = null;
    this.resize();
  }
  MatrixRain.prototype.readCfg = function () {
    var d = this.host.dataset;
    var preset = d.matrixPreset || 'bara_rose';
    var chars = (preset === 'custom' && d.matrixChars) ? d.matrixChars : (CHARSETS[preset] || CHARSETS.bara_rose);
    return {
      chars: chars.split(''),
      c1: d.matrixColor1 || '#18D8FF',
      c2: d.matrixColor2 || '#8B5CFF',
      speed: Math.max(1, +d.matrixSpeed || 8),     // 1–20 (higher = faster)
      density: Math.max(1, +d.matrixDensity || 7), // 1–20 (higher = denser)
      font: Math.max(8, +d.matrixFont || 14),
      pauseOnScroll: d.matrixPauseScroll === 'on'
    };
  };
  MatrixRain.prototype.resize = function () {
    var r = this.host.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.W = r.width; this.H = r.height;
    this.canvas.width = this.W * dpr; this.canvas.height = this.H * dpr;
    this.canvas.style.width = this.W + 'px'; this.canvas.style.height = this.H + 'px';
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var step = this.cfg.font * (22 - this.cfg.density) / 12; // density → column spacing
    this.colW = Math.max(this.cfg.font, step);
    this.cols = Math.ceil(this.W / this.colW);
    this.drops = [];
    for (var i = 0; i < this.cols; i++) this.drops[i] = Math.random() * -this.H;
  };
  MatrixRain.prototype.frame = function (ts) {
    if (!this.running) return;
    this.raf = requestAnimationFrame(this.frame.bind(this));
    if (this.paused) return;
    var interval = 90 - this.cfg.speed * 3.5; // speed → ms per step
    if (ts - this.last < interval) return;
    this.last = ts;
    var ctx = this.ctx, cfg = this.cfg;
    // fade trail
    ctx.fillStyle = 'rgba(5,5,9,0.18)';
    ctx.fillRect(0, 0, this.W, this.H);
    ctx.font = cfg.font + "px 'Space Mono', ui-monospace, monospace";
    for (var i = 0; i < this.cols; i++) {
      var ch = cfg.chars[(Math.random() * cfg.chars.length) | 0];
      var x = i * this.colW, y = this.drops[i];
      ctx.fillStyle = (i % 3 === 0) ? cfg.c2 : cfg.c1;
      ctx.shadowColor = ctx.fillStyle; ctx.shadowBlur = 6;
      ctx.fillText(ch, x, y);
      ctx.shadowBlur = 0;
      if (y > this.H && Math.random() > 0.975) this.drops[i] = Math.random() * -80;
      else this.drops[i] = y + this.cfg.font;
    }
  };
  MatrixRain.prototype.start = function () {
    if (this.running) return;
    this.resize();
    if (!this.cols) {
      // host measured 0×0 (e.g. mid open-transition before layout settles) — retry
      // next frame instead of silently staying blank forever. Bounded so a
      // permanently-hidden host can't spin forever.
      this._startRetries = (this._startRetries || 0) + 1;
      if (this._startRetries < 60) {
        var self = this;
        requestAnimationFrame(function () { self.start(); });
      }
      return;
    }
    this._startRetries = 0;
    if (REDUCE.matches) { this.paintStatic(); return; } // no animation under reduced motion
    this.running = true; this.last = 0;
    this.raf = requestAnimationFrame(this.frame.bind(this));
    if (this.cfg.pauseOnScroll) this.bindScroll();
  };
  MatrixRain.prototype.stop = function () {
    this.running = false;
    if (this.raf) cancelAnimationFrame(this.raf);
    if (this.scrollHandler) { this.scroller && this.scroller.removeEventListener('scroll', this.scrollHandler); this.scrollHandler = null; }
  };
  MatrixRain.prototype.bindScroll = function () {
    var self = this, t;
    // pause while the drawer body scrolls, resume shortly after
    this.scroller = this.host.closest('.mmm-drawer') || this.host.parentElement;
    this.scrollHandler = function () {
      self.paused = true; clearTimeout(t);
      t = setTimeout(function () { self.paused = false; }, 220);
    };
    this.scroller.addEventListener('scroll', this.scrollHandler, { passive: true, capture: true });
  };
  MatrixRain.prototype.paintStatic = function () {
    var ctx = this.ctx, cfg = this.cfg;
    ctx.clearRect(0, 0, this.W, this.H);
    ctx.font = cfg.font + "px 'Space Mono', ui-monospace, monospace";
    ctx.globalAlpha = 0.5;
    for (var i = 0; i < this.cols; i++) {
      var n = 3 + ((Math.random() * 4) | 0);
      for (var j = 0; j < n; j++) {
        ctx.fillStyle = (i % 3 === 0) ? cfg.c2 : cfg.c1;
        ctx.fillText(cfg.chars[(Math.random() * cfg.chars.length) | 0], i * this.colW, Math.random() * this.H);
      }
    }
    ctx.globalAlpha = 1;
  };

  /* ========================================================================
     STAGGER — assign --i to children of [data-mmm-stagger] containers so the
     CSS entrance delays cascade. Pure index assignment; CSS does the motion.
     ======================================================================== */
  function applyStagger(drawer) {
    var groups = drawer.querySelectorAll('[data-mmm-stagger]');
    groups.forEach(function (g) {
      var kids = g.children;
      for (var i = 0; i < kids.length; i++) kids[i].style.setProperty('--i', i);
    });
    // explicit per-item lists (search/extras/nav/tiles/products) can also opt in
    var items = drawer.querySelectorAll('[data-mmm-stagger-item]');
    items.forEach(function (el, i) { el.style.setProperty('--i', i % 14); });
  }

  /* ========================================================================
     EMPTY TILES — mark tiles whose image failed/absent so CSS can render the
     chosen empty style, and drop in the category initial for orbs.
     Non-destructive: only adds classes/spans, never removes the link.
     ======================================================================== */
  function flagEmptyTiles(drawer) {
    var links = drawer.querySelectorAll('.mmm-grid__link');
    links.forEach(function (link) {
      if (link.classList.contains('mmm-grid__viewall') || link.dataset.mmmEmptyChecked) return;
      link.dataset.mmmEmptyChecked = '1';
      var img = link.querySelector('.mmm-grid__img-wrap img');
      var hasImg = img && (img.currentSrc || img.getAttribute('src'));
      if (!hasImg) {
        link.classList.add('is-empty');
        addInitial(link);
      } else if (img) {
        img.addEventListener('error', function () { link.classList.add('is-empty'); addInitial(link); }, { once: true });
      }
    });
  }
  function addInitial(link) {
    var wrap = link.querySelector('.mmm-grid__img-wrap');
    if (!wrap || wrap.querySelector('.mmm-grid__initial')) return;
    var label = link.querySelector('.mmm-grid__label');
    var txt = (label && label.textContent.trim().charAt(0)) || '✦';
    var span = document.createElement('span');
    span.className = 'mmm-grid__initial'; span.setAttribute('aria-hidden', 'true');
    span.textContent = txt.toUpperCase();
    wrap.appendChild(span);
  }

  /* ========================================================================
     MATRIX TARGET ROUTING — moves the single canonical [data-mmm-matrix]
     host to the container named by its data-matrix-target. Never clones;
     only re-parents (cheap DOM move). Each branch is commented with the
     setting value it serves so it's easy to match against the schema.
     ======================================================================== */
  function tilesGridFor(drawer) {
    // Matrix target: tiles — follow the active panel's *visible* grid: the
    // open Level-3 drill-down grid if the user has drilled in, else the
    // Level-2 grid. Read-only: this never toggles the L3 show/hide itself.
    var panel = drawer.querySelector('.mmm-panel.is-active');
    if (!panel) return null;
    var l3s = panel.querySelectorAll('.mmm-panel__l3');
    for (var i = 0; i < l3s.length; i++) {
      if (l3s[i].style.display === 'block') return l3s[i].querySelector('.mmm-grid');
    }
    var l2 = panel.querySelector('.mmm-panel__l2');
    return l2 ? l2.querySelector('.mmm-grid') : null;
  }

  function placeMatrixHost(drawerHostEl) {
    var host = drawerHostEl.querySelector('[data-mmm-matrix]');
    if (!host) return null; // matrix_enable is off — nothing to place
    var drawer = drawerHostEl.querySelector('.mmm-drawer');
    if (!drawer) return host;
    var target = host.dataset.matrixTarget || 'drawer_background';
    var dest;

    if (target === 'drawer_overlay') {
      // Matrix target: overlay — behind the dimmed backdrop, outside the drawer panel.
      dest = drawerHostEl.querySelector('#Drawer-Overlay-Menu');
    } else if (target === 'right_panel_only') {
      // Matrix target: right panel — behind the category/tile panels only.
      dest = drawer.querySelector('.mmm-panels');
    } else if (target === 'left_nav_only') {
      // Matrix target: left nav — behind the Level-1 category list only.
      dest = drawer.querySelector('.mmm-nav');
    } else if (target === 'tiles_only') {
      // Matrix target: tiles — behind the active panel's visible tile grid only.
      dest = tilesGridFor(drawer);
    } else {
      // Matrix target: drawer background (default) — behind the whole drawer.
      dest = drawer;
    }
    if (!dest) dest = drawer; // safe fallback if a target container isn't present this render

    if (host.parentElement !== dest) {
      if (dest === drawer) {
        dest.insertBefore(host, dest.firstChild); // first child: keeps the [role="dialog"] z-index:1 rule effective
      } else {
        dest.appendChild(host); // append-only: never shifts existing :nth-child-based selectors (e.g. tile stagger delays)
      }
    }
    return host;
  }

  /* ========================================================================
     ORCHESTRATION — boot once the drawer exists; react when it opens/closes.
     Drawer "open" is detected by [open] / .is-open / aria-hidden flips on
     <side-drawer id="Drawer-Menu"> — matching all common Ella/Shopify drawers.
     ======================================================================== */
  var rains = [];
  var tilesObserver = null; // only used when matrix_target = tiles_only
  function isOpen(host) {
    return host.hasAttribute('open') || host.classList.contains('is-open') ||
           host.getAttribute('aria-hidden') === 'false';
  }
  function onOpen(drawerHostEl) {
    var drawer = drawerHostEl.querySelector('.mmm-drawer') || drawerHostEl;
    applyStagger(drawer);
    flagEmptyTiles(drawer);

    var matrixHost = placeMatrixHost(drawerHostEl);
    if (matrixHost) {
      if (!rains.length) rains.push(new MatrixRain(matrixHost));
      rains.forEach(function (r) { r.resize(); r.start(); });

      // Matrix target: tiles — the active grid changes on tab switch / L3
      // drilldown while the drawer stays open, so keep the host following it.
      // Purely observational: never touches the tab/L3 click handlers itself.
      if (matrixHost.dataset.matrixTarget === 'tiles_only' && !tilesObserver) {
        var panels = drawer.querySelector('.mmm-panels');
        if (panels) {
          tilesObserver = new MutationObserver(function () {
            placeMatrixHost(drawerHostEl);
            rains.forEach(function (r) { r.resize(); });
          });
          tilesObserver.observe(panels, { attributes: true, attributeFilter: ['class', 'style'], subtree: true });
        }
      }
    }
  }
  function onClose() {
    rains.forEach(function (r) { r.stop(); });
    if (tilesObserver) { tilesObserver.disconnect(); tilesObserver = null; }
  }

  function boot() {
    var host = document.querySelector(DRAWER_SEL);
    if (!host) return;
    // Re-check MQ.matches live on every open/close, not just once here at boot
    // time — boot() can run while the Shopify theme editor's preview pane is
    // still at a desktop width (before switching to mobile preview), and a
    // one-time check at that instant would permanently disable everything
    // below for the rest of the page's life even after switching to mobile.
    var obs = new MutationObserver(function () {
      if (!MQ.matches) return;
      isOpen(host) ? onOpen(host) : onClose();
    });
    obs.observe(host, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'] });
    if (MQ.matches && isOpen(host)) onOpen(host); // already open (rare)
    // keep canvas crisp on rotation/resize
    window.addEventListener('resize', function () { rains.forEach(function (r) { r.resize(); }); }, { passive: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
